export default __webpack_public_path__ + "static/Tangle1-c92f5dbe912fc75c0e7c041ba28947f4.jpg";